module.exports = __webpack_public_path__ + "img/paytable_icon.abdc5ea8.svg";